export enum Language {
  Polish = 'pl',
  English = 'en'
}